import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot, type CanActivateFn, type RouterStateSnapshot } from '@angular/router';

import { DEFAULT_LANGUAGE, languages } from './constants';
import { LangService } from './lang-service';

export const canActivateLang: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const langservice = inject(LangService);

  const language = route.params['lang'];

  const supportedLanguages = languages.map((lang) => lang.code);

  const urlSegments = route.url.map((segment) => segment.path);

  if (supportedLanguages.includes(language)) {
    langservice.setUrl(urlSegments.join('/'));

    return true;
  }

  console.warn(`Unsupported language: ${language}. Falling back to '${DEFAULT_LANGUAGE}'.`);

  urlSegments[0] = DEFAULT_LANGUAGE;

  const redirectPath = urlSegments.join('/');

  langservice.setUrl(redirectPath);

  return true;
};
